import React, { Component } from 'react';
import './Switch.css'

class Switch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			enabled: false,
		};
	};

	handleOnClick = (event) => {
		this.props.handleToggleSwitch(event.target.value);
	}

	render() {
		let style = {

		};

		style = Object.assign(style, this.props.style);
		var handleToggleSwitch = this.props.handleToggleSwitch;

		return (
			<div id={'switch_' + this.props.id} style={style}>
				<label className="switch">
					<input type="checkbox" checked={this.props.is_enabled} value={this.props.name} key={this.props.name} onChange={(event) => this.handleOnClick(event)} />
					<span className="slider round"></span>
				</label>
			</div>
		);
	}
}


export default Switch;